import { Expose } from "class-transformer";

export class CreateLocationDto {
  @Expose()
  name: string;

  @Expose()
  isOpen: boolean;

  @Expose()
  warehouseId: string;
}
